<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Blätterfall</h3>
<p class="vers">Er kommt heran mit leisem Schritte<br class="calibre2"/>
in stiller Nacht<br class="calibre2"/>
und hat umreift so Baum als Hütte,<br class="calibre2"/>
eh du erwacht.</p>
<p class="vers">Du öffnest deiner Pforte Riegel<br class="calibre2"/>
und trittst hinaus,<br class="calibre2"/>
Reifsilber blinkt um Wald und Hügel<br class="calibre2"/>
und um dein Haus.</p>
<p class="vers">Noch stehen dicht belaubt die Bäume.<br class="calibre2"/>
O still, o still,<br class="calibre2"/>
wer nicht die letzten Frühlingsträume<br class="calibre2"/>
verscheuchen will.</p>
<p class="vers">Von Blatt zu Blatte tönt hinüber<br class="calibre2"/>
ein trübes Wort:<br class="calibre2"/>
Der Lenz, das Leben ist vorüber,<br class="calibre2"/>
wir müssen fort!</p>
<p class="vers">Und ach, die Sonne, die sonst immer<br class="calibre2"/>
das Licht gebracht,<br class="calibre2"/>
sie bringt mit ihrem goldnen Schimmer<br class="calibre2"/>
uns heut die Nacht.</p>
<p class="vers"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page23" title="wedi/Konmax"></a> Da steigt sie eben durch die Föhren<br class="calibre2"/>
am Waldessaum,<br class="calibre2"/>
schon fallen leise Silberzähren<br class="calibre2"/>
von Strauch und Baum.</p>
<p class="vers">O halte deine güldnen Sohlen,<br class="calibre2"/>
o bleibe stehn,<br class="calibre2"/>
daß wir noch einmal Atem holen<br class="calibre2"/>
und dann vergehn.</p>
<p class="vers">Doch wie die Blätter alle klagen,<br class="calibre2"/>
sie hört es nicht<br class="calibre2"/>
und hebt wie sonst den güldnen Wagen<br class="calibre2"/>
und spendet Licht.</p>
<p class="vers">Sie kommt mit heißen Flammenbächen,<br class="calibre2"/>
so hell, so rot,<br class="calibre2"/>
sie will des Winters Siegel brechen<br class="calibre2"/>
und bringt den Tod.</p>
<p class="vers">Da klingt die alte Wehmutsweise<br class="calibre2"/>
durchs weite All,<br class="calibre2"/>
und in die Laute raschelt leise<br class="calibre2"/>
der Blätterfall. <a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page24" title="Wunibald/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0008.vue?5c4dd43c